import { Injectable } from "@angular/core";
import { ProcedureBase } from "../../model/procedure/procedure.model";
import { ServiceBase } from "../../model/service/service.model";
import { ProcedureInstanceService } from "./procedure-instance.service";
import { Observable } from "rxjs";
import { CacheService } from "../cache/cache.service";


@Injectable({
	providedIn: 'root'
})
export class ProcedureInstanceConfigCacheService {

	protected servicesConfig: Map<string, { procedureTO: ProcedureBase, serviceTO: ServiceBase }> = new Map();

	constructor(protected cacheService: CacheService, protected procedureInstanceService: ProcedureInstanceService) {
		cacheService.clearCache$.subscribe(p => {
			this.clear()
		})
	}

	preloadServicesConfigCache(serviceId: number, procedureId: number, value: { procedureTO: ProcedureBase, serviceTO: ServiceBase }) {
		this.servicesConfig.set(serviceId + "-" + procedureId, value)
	}

	clear(): void {
		this.servicesConfig.clear()
	}

}
